export default {"src":"/_next/static/media/community.dcb208ed.svg","height":45,"width":50,"blurWidth":0,"blurHeight":0};